import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { es } from 'vuetify/locale'
import defaults from './defaults'
import { icons } from './icons'
import { themes } from './theme'

import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default function (app) {
  // Lee el tema guardado antes de crear Vuetify
  const cached = JSON.parse(localStorage.getItem('appTheme') || '{}')

  // Inyecta el color primario en ambos temas si existe
  if (cached?.primary_color) {
    themes.light.colors.primary = cached.primary_color
    themes.dark.colors.primary = cached.primary_color
  }

  const vuetify = createVuetify({
    aliases: { IconBtn: VBtn },
    locale: {
      locale: 'es',
      messages: { es },
    },
    defaults,
    icons,
    theme: {
      defaultTheme: 'light',
      themes,
    },
  })

  app.use(vuetify)
}
